import React, { useEffect } from "react";
import styled from "styled-components";
import Routes from "./Components/Routes";
import Helmet from "react-helmet";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "styled-components";
import axios from "axios";
import Web3 from "web3";
import { Button, Input as _Input, Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup } from "reactstrap";

// import ReactGA from "react-ga";
import {
  HOST,
  NODE_ENDPOINT,
  GAS_PRICE_API,
  CHAIN_ID,
  CHAIN_NAME,
  CONTRACT_ADDRESS,
  ETHERSCAN_TX_URL,
} from "./Utils/constants";
import Theme from "./Styles/Theme";
import GlobalContext from "./Hooks/globalContext";
import useState from "./Hooks/useState";
import GlobalStyles from "./Styles/GlobalStyle";
import languagePack from "./Utils/language";
import { ToFixed } from "./Utils/util";

import lcmsContract from "./Resources/Contract/lcms";

const Wrapper = styled.div`
  height: 100%;
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const web3 = new Web3(
  new Web3.providers.HttpProvider(NODE_ENDPOINT, {
    headers: [],
  })
);

// ReactGA.initialize("UA-161528891-1");

const App = () => {
  const getLanguage = (myLanguage) => {
    switch (myLanguage) {
      case "ko":
        return "korean";
      case "en":
        return "english";
      default:
        return "english";
    }
  };

  const isLogin = useState(
    (localStorage.getItem("token") ? true : false) || (sessionStorage.getItem("token") ? true : false)
  );
  const toggleMain = useState(false);
  const contract = useState(null);
  const modal = useState(false);
  const balance = useState({});
  const isSession = useState(sessionStorage.getItem("token") ? true : localStorage.getItem("token") ? false : null);
  const user = useState(null);
  const historyFunction = useState(false);
  const language = useState(getLanguage(navigator.language.substring(0, 2)));
  const sidebar = useState(false);
  const pushToken = useState(null);

  const logout = () => {
    isLogin.setState(false);
    user.setState({});
    balance.setState({});
    if (isSession.state) {
      sessionStorage.removeItem("token");
    } else {
      localStorage.removeItem("token");
    }
  };

  const setLanguage = ({ target }) => {
    if (target.value !== "") {
      language.setState(target.value);
    }
  };

  const httpHeader = (token = null) => {
    const httpHeader = {
      headers: {
        Authorization: `Bearer ${
          token
            ? token
            : sessionStorage.getItem("token")
            ? sessionStorage.getItem("token")
            : localStorage.getItem("token")
        }`,
      },
    };
    return httpHeader;
  };

  const getUser = async (token = null) => {
    try {
      const me = await axios.post(`${HOST}/user/info`, { detail: true }, httpHeader(token));
      user.setState(me.data.user);
      return me.data.user;
    } catch (e) {
      if (e.message === "Request failed with status code 401") {
        isLogin.setState(false);
        user.setState({});
        if (isSession.state) {
          sessionStorage.removeItem("token");
        } else {
          localStorage.removeItem("token");
        }
        return "expired";
      }
    }
  };

  const sendEth = async ({ address, fee, to, amount, isLoading, confirm, reject }) => {
    const count = await getTxCount(address);
    const gasPrice = (fee / 10).toString();
    const weiGasPrice = web3.utils.toWei(gasPrice, "gwei");
    const convertedGas = web3.utils.fromWei(`21000`, "gwei");
    const hexGasPrice = web3.utils.toHex(weiGasPrice);

    const requestBody = {
      rawTransaction: {
        from: address,
        gasPrice: hexGasPrice,
        gasLimit: web3.utils.toHex(21000),
        to,
        value: web3.utils.toHex(web3.utils.toWei(amount.toString(), "ether")),
        chainId: CHAIN_ID,
        nonce: web3.utils.toHex(count),
      },
      CHAIN_NAME,
      amount,
      fee: convertedGas * gasPrice,
      to,
      sendType: "eth",
    };

    const { data } = await axios.post(`${HOST}/wallet/send`, requestBody, httpHeader());
    if (data.status) {
      window.open(`${ETHERSCAN_TX_URL}/${data.hash}`);
      confirm(data.hash);
    } else {
      reject();
    }
    isLoading.setState(false);
  };

  const sendToken = async ({ address, fee, to, amount, isLoading, confirm, reject, symbol }) => {
    const count = await getTxCount(address);
    const gasPrice = (fee / 10).toString();
    const weiGasPrice = web3.utils.toWei(gasPrice, "gwei");
    const convertedGas = web3.utils.fromWei(`21000`, "gwei");
    const hexGasPrice = web3.utils.toHex(weiGasPrice);

    const [sorted] = CONTRACT_ADDRESS.filter(({ name, address }, index) => {
      if (name === symbol) {
        return address;
      }
    });

    let dynamicAmount = symbol === "usdt" ? Number(amount + "000000").toString() : web3.utils.toWei(amount);

    let eg = 0;
    eg = await contract.state[symbol].methods.transfer(to, dynamicAmount).estimateGas({ from: address });
    const requestBody = {
      rawTransaction: {
        from: address,
        gasPrice: hexGasPrice,
        gasLimit: web3.utils.toHex(eg),
        to: sorted.address,
        value: "0x0",
        data: contract.state[symbol].methods.transfer(to, dynamicAmount).encodeABI(),
        nonce: web3.utils.toHex(count),
      },
      CHAIN_NAME,
      amount,
      fee: convertedGas * gasPrice,
      to,
      sendType: symbol,
    };

    const { data } = await axios.post(`${HOST}/wallet/send`, requestBody, httpHeader());

    if (data.status) {
      window.open(`${ETHERSCAN_TX_URL}/${data.hash}`);
      confirm(data.hash);
    } else {
      reject();
    }
    isLoading.setState(false);
  };

  const getTxCount = async (address) => {
    const count = await web3.eth.getTransactionCount(address, "pending");
    return count;
  };

  const refreshEth = async (symbol, rowAddress) => {
    balance.setState({ ...balance.state, eth: undefined });
    const _balance = await web3.eth.getBalance(rowAddress ? rowAddress : user.state.address);
    const convertedBalance = ToFixed(web3.utils.fromWei(_balance), 10000);
    return convertedBalance;
  };

  const refreshToken = async (symbol, rowAddress) => {
    const _balance = await contract.state[symbol].methods
      .balanceOf(rowAddress ? rowAddress : user.state.address)
      .call();
    if (symbol === "usdt") {
      const convertedBalance = ToFixed(web3.utils.fromWei(_balance + "000000000000"), 10000);
      return convertedBalance;
    } else {
      const convertedBalance = ToFixed(web3.utils.fromWei(_balance), 10000);
      return convertedBalance;
    }
  };
  const getBalance = async (symbol, admin = false, rowAddress = null) => {
    switch (symbol) {
      case "eth":
        const _eth = await refreshEth(symbol, rowAddress);
        balance.setState({ ...balance.state, eth: _eth });
        return;
      case "lcms":
        balance.setState({ ...balance.state, lcms: undefined });
        const lcmsBalance = await refreshToken(symbol, rowAddress);
        balance.setState({ ...balance.state, lcms: lcmsBalance });
        return;
      case "esg":
        balance.setState({ ...balance.state, esg: undefined });
        const esgBalance = await refreshToken(symbol, rowAddress);
        balance.setState({ ...balance.state, esg: esgBalance });
        return;
      case "usdt":
        balance.setState({ ...balance.state, usdt: undefined });
        const usdtBalance = await refreshToken(symbol, rowAddress);
        balance.setState({ ...balance.state, usdt: usdtBalance });
        return;
      default:
        const eth = await refreshEth(symbol, rowAddress);
        const esg = await refreshToken("esg", rowAddress);
        const lcms = await refreshToken("lcms", rowAddress);
        const usdt = await refreshToken("usdt", rowAddress);
        const merged = {
          eth,
          esg,
          lcms,
          usdt,
        };

        if (!admin) {
          balance.setState(merged);
        } else {
          return merged;
        }
        return;
    }
  };

  const balanceConvert = (eth) => {
    try {
      const numberEth = Number(eth);
      const converted = numberEth.toFixed(9);
      const result = converted.substring(0, converted.length - 1);
      return Number(result);
    } catch (e) {
      return eth;
    }
  };

  const sidebarToggle = () => {
    sidebar.setState(!sidebar.state);
  };

  const preload = () => {
    window.addEventListener("message", function (event) {
      if (event.data && event.data !== "undefined") {
        try {
          const parsed = JSON.parse(event.data);
          pushToken.setState(parsed.pushToken);
        } catch (e) {}
      }
    });
    document.addEventListener("message", function (event) {
      if (event.data && event.data !== "undefined") {
        try {
          const parsed = JSON.parse(event.data);
          pushToken.setState(parsed.pushToken);
        } catch (e) {}
      }
    });
  };

  const setContract = () => {
    const userInit = async () => {
      await getUser();
    };

    const contractInit = async () => {
      await loginHandler();
    };

    if (!user.state && isLogin.state) {
      userInit();
    }

    if (!contract.state && isLogin.state) {
      contractInit();
    }
  };

  const loginHandler = () => {
    const initialize = async () => {
      const _user = await getUser();
      if (_user === "expired") {
        modal.setState(languagePack("보안을 위해 로그아웃합니다. 다시 로그인해주세요.", language.state));
        logout();
        return;
      }
      const contracts = [];

      await Promise.all(
        CONTRACT_ADDRESS.map(async ({ address, name }, index) => {
          switch (name) {
            case "lcms":
              contracts[name] = new web3.eth.Contract(lcmsContract, address);
              break;
            case "usdt":
              contracts[name] = new web3.eth.Contract(lcmsContract, address);
              break;
            case "esg":
              contracts[name] = new web3.eth.Contract(lcmsContract, address);
              break;
          }
        })
      );
      contract.setState(contracts);
    };
    if (isLogin.state) {
      initialize();
    }
  };

  const toggleModal = ({ text }) => {
    modal.setState(text ? text : null);
  };

  useEffect(() => {
    setContract();
  }, [isLogin.state]);

  useEffect(() => {
    preload();
  }, []);

  const contextValue = {
    isLogin,
    toggleModal,
    modal,
    user,
    getUser,
    logout,
    historyFunction,
    language,
    setLanguage,
    httpHeader,
    web3,
    getTxCount,
    balanceConvert,
    getBalance,
    contract,
    sendToken,
    sendEth,
    isSession,
    sidebarToggle,
    pushToken,
    modal,
    balance,
    toggleMain,
  };

  return (
    <>
      <GlobalStyles />
      <GlobalContext.Provider value={contextValue}>
        <ThemeProvider theme={Theme}>
          <Router>
            <Helmet>
              <meta name="viewport" content="initial-scale=1.0,user-scalable=no,maximum-scale=1,width=device-width" />
            </Helmet>
            <div>
              <Modal centered={true} isOpen={!!modal.state} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}> {languagePack("알림", language.state)}</ModalHeader>
                <ModalBody>{modal.state}</ModalBody>
                <ModalFooter>
                  <Button style={{ backgroundColor: Theme.mainColor, border: 0 }} onClick={toggleModal}>
                    {languagePack("확인", language.state)}
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
            <Wrapper>
              <InnerWrapper>
                <Routes />
              </InnerWrapper>
            </Wrapper>
          </Router>
        </ThemeProvider>
      </GlobalContext.Provider>
    </>
  );
};

export default App;
